import type React from 'react';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import Icon from '../../../../../../../stories/Atoms/Icon/Icon';
import type { FAQDoc } from '../../../../../general/Input';
import type { BankDetail, CustomerService } from '../../../../types';
import styles from '../../../../../../general/Question/Faq.module.scss';

export interface QuestionProps {
    bankDetail: BankDetail;
    contactInfo: CustomerService;
    faq: FAQDoc;
    faqUri: string;
    selectedQuestionId:string;
}

const Question: React.FC<QuestionProps> = ({ bankDetail, contactInfo, faq, faqUri, selectedQuestionId }) => {
    const initialOpenValue = faq.objectID === selectedQuestionId;

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (initialOpenValue) {
            setIsOpen(initialOpenValue);
        }
    }, [initialOpenValue]);

    const questionID = `question${faq.objectID}`;

    const onClick = () => {
        setIsOpen(!isOpen);
        history.replaceState({}, '', `${faqUri}#${questionID}`);
    };

    return (
        <div id={`question${faq.objectID}`} className={classNames(styles.Faq, { [styles.Faq_opened as string]: isOpen })}>
            <button className={styles.Faq__question} onClick={onClick} type="button">
                <span>
                    {faq.question}
                </span>
                <Icon name={isOpen ? 'fa-minus' : 'fa-plus'} className={styles.Faq__question__icon} />
            </button>
            <div className={styles.Faq__answer}>
                <div className="p" dangerouslySetInnerHTML={{ __html: faq.answer.replace('((iban))', bankDetail.iban)
                    .replace('((bic))', bankDetail.bic)
                    .replaceAll('((cs_phone_number))', contactInfo.customerServicePhoneNumber)
                    .replaceAll('((cs_phone_number_formatted))', contactInfo.customerServicePhoneNumberFormatted)
                    .replaceAll('((cs_email_address))', contactInfo.customerServiceEmailAddress)
                    .replaceAll('((b2b_phone_number))', contactInfo.businessPhoneNumber)
                    .replaceAll('((b2b_phone_number_formatted))', contactInfo.businessPhoneNumberFormatted)
                    .replaceAll('((b2b_email_address))', contactInfo.businessEmailAddress) }}
                />
            </div>
        </div>
    );
};

export default Question;
